import React, { useEffect, useRef, useState, useMemo } from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../../CustomComponents/Loader';
import { useLocation, useNavigate } from 'react-router-dom';
import { withOidcSecure } from '@axa-fr/react-oidc';
import HomeLayout from '../../../Layout/HomeLayout';
import HomeHeader from '../../../CustomComponents/HomeHeader';
import { useKeyDown } from '../../../../hooks/useKeyDown';
import { ACTIVATE_CARD_INLIFE,CANCEL_UPCOMING_TRANSACTION ,GENERATE_ACTIVATE_CARD_OTP, GENERATE_EXISTING_PHONE_EMAIL_OTP, GENERATE_OTP_CHANGE_PIN, GENERATE_OTP_VIEW_CARD, GET_ADD_NEW_CARD_METADATA, GET_CARDHOLDER_CARDS, GET_PIN_CHANGE_DETAILS, GET_SHIPPING_ID, LOCK_CARD_API, POST_LOGIN, POST_PIN_CHANGE, REPLACE_CARD_API, REPORT_LOST_CARD_API, STATUS_SUCCESS_CODE, UNLOCK_CARD_API, RESTORE_RECURRING_PAYMENTS, MERCHANT_RECURRING_STOP, RESTORE_RECCURRING_PAYMENTS_UPDATED } from '../../../../network/URLConstants';
import { GetApiHeadersWithBearer, GetRequest, PostRequest } from '../../../../network/NetworkUtils';
import CustomAlertModel from '../../../CustomComponents/CustomAlertModel';
import { appTheme, retrieveData } from '../../../../helpers/utils/Utils';
import Custom2FA from '../../../CustomComponents/Custom2FA';
import Modal from '../../../CustomComponents/Modal';
import { LOGIN_SESSION_KEY } from '../../../../Redux/reducers';
import { addLineBreaks, displayErrorMessage, displayKudzuplusErrorMessage } from '../../../../utils';
import CardMenu from '../../CardMenu';
import DynamicCard from '../../../CustomComponents/DynamicHomeCard';
import { width } from "../../../CustomComponents/Card/CardStyles";
import moment from 'moment';
import TermsArrow from '../../../../assets/images/terms_arrow.png';
import report_a_problem_flag from '../../../../assets/images/report_a_problem_flag.png';
import dollorRecuuring from '../../../../assets/images/dollor_reccuring.png'
import CardHeading from '../../../CustomComponents/CardHeading';
import Dollor_Tick from '../../../../assets/images/dollor_tick.png';
import ToolTipQuestionMark from '../../../../assets/images/tooltip_question.png';
import CustomDatePicker from '../../../CustomComponents/CustomDateInput'
import StopPaymentDurationModal from '../StopPaymentDurationModal';


const LocalClickableTooltip = ({ text, children }) => {
    const [isVisible, setIsVisible] = useState(false);
    const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
    const appThemeData = appTheme(kudzuPlusTrue);

    const handleClick = () => {
        setIsVisible(!isVisible);
    };

    return (
        <div className="relative inline-block" onClick={handleClick}>
            {children}
            {isVisible && (
                <div className={`z-30 tooltip w-[125px] h-[86px] ${kudzuPlusTrue ? 'bg-[#3C66FF] text-white' : 'bg-[#D6E2E8] text-[#262B3A]'} font-hanken-grotesk font-[700] text-[9px] leading-[13px] text-left p-3 rounded-xl absolute top-[150%] left-1/2 transform -translate-x-1/2 transition-opacity duration-300 opacity-100`}>
                    {kudzuPlusTrue ? <div className="tooltip-arrow-comparion"></div> : <img src={appThemeData.tooltipArrowForNotification} alt="arrow" className='absolute -top-[8px] left-0' />}
                    {text}
                </div>
            )}
        </div>
    );
};


const ManageRecurringPaymentsDetails = () => {
    const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
    const appThemeData = appTheme(kudzuPlusTrue);
    const dispatch = useDispatch();
    const { t } = useTranslation(); // Hook to access translation functions

    // Set page title
    useEffect(() => {
        document.title = t('page_title_recurring_payment_details');
    }, [t]);
    const cards = useSelector(state => JSON.parse(state.userCards));
    const accessTokenToApi = useSelector(state => state.accessToken);
    const [isOTPVerifyModalOpen, setIsOTPVerifyModalOpen] = useState(false);
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate();
    const [showModel, setShowModel] = useState(false);
    const HighlightMsgStyles = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal  text-[var(--modal-text-highlight)] cursor-pointer pointer-events-none";
    const HeaderMsgStyles = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal cursor-pointer pointer-events-none text-[var(--modal-text-heading-clr)]";
    const SubHeaderMsgStyles = "font-hanken-grotesk text-[var(--modal-text-heading-clr)] modal-title lg:text-[20px] md:text-[18px] sm:text-[14px] text-[16px] font-normal cursor-pointer pointer-events-none";
    const [highlightMsg, setHighlightMsg] = useState('')
    const [headerMsg, setheaderMsg] = useState('')
    const [subHeaderMsg, setSubHeaderMsg] = useState('')
    const [btn1Exists, setBtn1Exists] = useState(false)
    const [btn2Exists, setBtn2Exists] = useState(false)
    const [btn1Text, setBtn1Text] = useState(false)
    const [btn2Text, setBtn2Text] = useState('')
    const [modelImage, setModelImage] = useState('')
    const [btn1TypeAcpt, setBtn1TypeAcpt] = useState(false)
    const [footerMsg, setFooterMsg] = useState('');
    const [btn1Focus, setBtn1Focus] = useState(false);
    const [btn2Focus, setBtn2Focus] = useState(false);
    const [subFooter, setSubFooter] = useState('');
    const location = useLocation();
    const [setupPinURL, setSetupPinURL] = useState('');
    const [showSetupPinWebPage, setShowSetupPinWebPage] = useState(false);
    const [showActivateCard, setShowActivateCard] = useState(false);
    const [UpdatedArray, setUpdatedArray] = useState(useSelector(state => JSON.parse(state.userCards)));
    const [showResponse, setShowResponse] = useState(false);
    const [isBorderNone, setisBorderNone] = useState(true);
    const [showErrorImg, setshowErrorImg] = useState(false);
    const [currentStep, setCurrentStep] = useState(1);
    const [editableEndDate, setEditableEndDate] = useState(null);
    const editableEndDateRef = useRef(null)
    const userHasSelectedEndDateRef = useRef(false);
    const [isStopPaymentDurationModalOpen, setIsStopPaymentDurationModalOpen] = useState(false);
    const [selectedDuration, setSelectedDuration] = useState(3);

    useEffect(() => {
        editableEndDateRef.current = editableEndDate;
    }, [editableEndDate]);

    const cardDetails = useSelector(state => state.selectedCardDetails);

         const HeadingStyles =
    "font-serif-pro modal-title sm:text-[18px] lg:text-[32px] md:text-[28px] text-[25px] sm:leading-[24px] lg:leading-[38px] md:leading-[33px] leading-[31px] font-normal text-[var(--modal-text-highlight)]";
  const HeadingUpdatedStyles = 
    "font-serif-pro modal-title sm:text-[18px] lg:text-[32px] md:text-[28px] text-[25px] sm:leading-[24px] lg:leading-[38px] md:leading-[33px] leading-[31px] font-normal text-[var(--modal-text-heading-clr)]"
     const continueButtonClasses = `font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[13px] text-[14px] text-[#2965FB] cursor-pointer  flex items-center`;


    useEffect(() => {
        setShowActivateCard(true)
    }, []);


    useEffect(() => {
        // Listen for messages from the embedded iframe
        const handleMessage = (event) => {
            if (event.data == 0) {
                setSetupPinURL('')
                // updateCardStatus(selectedItem.CardKey, responseObj.Response)
                setShowSetupPinWebPage(true);
                callPostPinChangeApi(event.data)
                // Handle success case
            } else if (event.data == -1) {
                setShowSetupPinWebPage(true);
                setSetupPinURL('')
                callPostPinChangeApi(event.data)
                // Handle failure case
            }
        };

        window.addEventListener('message', handleMessage);

        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, []);


    useKeyDown(() => { }, ["Enter"]);
    const showAlertModal = (showModel, highlightMsg, headerMsg, subHeaderMsg, btn1Exists, btn2Exists, btn1Text, btn2Text, btn1TypeAcpt, modelImage, footerMsg, showErrorImg, isBorderNone, btn1Focus, btn2Focus) => {
        setshowErrorImg(showErrorImg)
        setisBorderNone(isBorderNone)
        setShowModel(showModel)
        setHighlightMsg(highlightMsg)
        setheaderMsg(headerMsg)
        setSubHeaderMsg(subHeaderMsg)
        setBtn1Exists(btn1Exists)
        setBtn2Exists(btn2Exists)
        setBtn1Text(btn1Text)
        setBtn2Text(btn2Text)
        setBtn1TypeAcpt(btn1TypeAcpt)
        setModelImage(modelImage)
        setFooterMsg(footerMsg)
        setBtn1Focus(btn1Focus)
        setBtn2Focus(btn2Focus)
    }
    const handleCardAction = (type) => {
        if (type == t('lock_card')) {
            showAlertModal(true, t("are_you_sure"), t("this_card_will_be_locked"), t('once_you_lock_your_card_any_new_transactions_will_be_declined'), true, true, t('lock_card'), t("cancel"), true, require('../../../../assets/images/lock_green.png'), '', false, true, false, true)
        } else if (type == t('unlock_card')) {
            showAlertModal(true, t("ready_to_unlock_questionmark"), t("unlock_your_card_to_resume_normal_use"), t('once_you_unlock_your_card_all_locked'), true, true, t('unlock_card'), t("cancel"), true, require('../../../../assets/images/unlock_green.png'), '', false, true, true, false)
        } else if (type == t('replace_card')) {
            navigate('/CardServices/CardActionScreen/ReplaceCard', { state: { item: cardDetails } })
        } else if (type == t('change_pin')) {
            navigate('/CardServices/CardActionScreen/ChangePin', { state: { item: cardDetails } })
        } else if (type == t('view_card_details')) {
            navigate('/CardServices/CardActionScreen/ViewCard', { state: { item: cardDetails } })
        } else if (type == t('activate_card')) {
            navigate('/CardServices/CardActionScreen/ActivateCard', { state: { item: cardDetails } })
        }
        // Archived - Manage Recurring Payments replaced with Stop a Recurring Payment (call support flow)
        // else if (type === t('CARD_SERVICE_MANAGE_RECURRING_PAYMENTS')) {
        //     navigate('/CardServices/CardActionScreen/ManageRecurringPayments', { state: { item: cardDetails } })
        // }
        else if(type === t('STOP_A_RECURRING_PAYMENT')){
            navigate('/CardServices/CardActionScreen/StopPaymentCallSupport', { state: { item: cardDetails } })
        }

    }
    const onAcptBtnClick = () => {
        if (btn1Text == t("lock_card")) {
            callApiToLockCard()
        } else if (btn1Text == t("unlock_card")) {
            callApiToUnlockCard()
        } else if (btn1Text == t('back_to_card_services')) {
            navigate('/CardServices')
        } else if (btn1Text == t('home')) {
            navigate('/home')
        } else if(btn1Text === t('back_to_account'))
        {
             navigate('/CardServices')
        }
    }
    const onCancelBtnClick = () => {
        if (btn2Text == 'Cancel') {
            setShowModel(false)
        } else if (btn2Text == t('back_to_card_services')) {
            navigate('/CardServices')
        }
    }
    const closeOTPVerifyModal = () => { setIsOTPVerifyModalOpen(false) }
    const closeModel = () => {
        if (showModel && (btn1Text == t('back_to_card_services') || btn2Text == t('back_to_card_services'))) { navigate('/CardServices') } else { setShowModel(false); }
    }
    const verificationSuccess = () => {
        setShowActivateCard(true)
        setShowResponse(false); setShowSetupPinWebPage(false);
    }
    const generate2FAOtp = async () => {
        const deviceId = await retrieveData('updatedDeviceId');
        const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);

        const requestObject = {
            cardKey: cards !== null ? cards[0].CardKey : 0
        };

        const url = GENERATE_ACTIVATE_CARD_OTP;
        setLoading(true);

        try {
            const response = await PostRequest(url, requestObject, headers);
            setLoading(false);

            const parsedResponse = JSON.parse(response);
            if (parsedResponse.ResponseCode === STATUS_SUCCESS_CODE) {
                const loginSessionPayLoad = { loggedSessionKey: parsedResponse.Response.sessionId }
                dispatch({ type: LOGIN_SESSION_KEY, payload: loginSessionPayLoad });
                const userIdPayload = { userId: parsedResponse.Response.userId }
                dispatch({ type: 'USER_ID', payload: userIdPayload });
                setTimeout(() => {
                    setIsOTPVerifyModalOpen(true);
                }, 1000);
            } else {
                const arrMessages = parsedResponse.Messages;
                const message = arrMessages[0];
                const displayText = message.DisplayText;
                setShowActivateCard(false)
                showAlertModal(true, t("oops_exclamation"), '', displayText, true, true, t('home'), t('back_to_card_services'), true, require('../../../../assets/images/warning.png'), '', false, false, true, false)

            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const callApiToLockCard = async () => {
        setLoading(true)
        setShowModel(false)


        const deviceId = await retrieveData('updatedDeviceId');
        const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
        let object = {
            CardKey: cardDetails !== null ? cardDetails.CardKey : 0
        }
        PostRequest(LOCK_CARD_API, object, headers).then((response) => {

            setTimeout(() => {
                setLoading(false)
            }, 500);

            let responseObj = JSON.parse(response);
            if (responseObj.ResponseCode == STATUS_SUCCESS_CODE) {

                setTimeout(() => {
                    updateCardStatus(cardDetails !== null ? cardDetails.CardKey : 0, responseObj.Response)
                    showAlertModal(true, t("done_exclamation"), t("this_card_is_now_locked"), t('any_new_tx_will_be_declined'), true, false, t('back_to_card_services'), '', true, require('../../../../assets/images/lock_green_tick.png'), '', false, false, true, false)
                }, 1000);


            } else {
                var arrMessages = responseObj.Messages;
                var message = arrMessages[0];
                var displayText = message.DisplayText;
                showAlertModal(true, t("oops_exclamation"), '', displayText, true, true, t('home'), t('back_to_card_services'), true, require('../../../../assets/images/warning.png'), '', false, false, true, false)
                setTimeout(() => {
                }, 1000);

            }

        });

    }

    const handleConfirmStopPayment = async () => {
        const deviceId = await retrieveData('updatedDeviceId');
        const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
        const cardKey = transactionDetails?.cardDetails?.CardKey;
        const transactionId = transactionDetails?.TransactionId;
        if (!transactionId || !cardKey) {
            showAlertModal(true, t("oops"), '', 'Missing transaction or card information', true, false, t('back_to_card_services'), '', true, require('../../../../assets/images/warning.png'), '', true, false);
            return;
        }
        let url = MERCHANT_RECURRING_STOP;
       const endDateToSend = editableEndDateRef.current ?? editableEndDate ?? new Date();  
        const object = {
             "duration": selectedDuration ?? 3,
            "startDate": endDateToSend,
            "cardKey":cardKey,
            "TransactionId":transactionId
        }
        setLoading(true);
        try {
            const response = await PostRequest(url, object, headers);
            setTimeout(() => {
                setLoading(false);
            }, 500);
            const responseObj = JSON.parse(response);
            if (responseObj.ResponseCode == STATUS_SUCCESS_CODE) {
                // Show success modal on API success
                setStopRecurringSuccessModal(true);
            } else {
                var arrMessages = responseObj.Messages;
                var message = arrMessages[0];
                var displayText = message.DisplayText;
                showAlertModal(true, t("oops"), '', displayText, true, false, t('back_to_card_services'), '', true, require('../../../../assets/images/warning.png'), '', true, false);
            }
        } catch (error) {
            setLoading(false);
            showAlertModal(true, t("oops"), '', 'An error occurred while stopping the payment', true, false, t('back_to_card_services'), '', true, require('../../../../assets/images/warning.png'), '', true, false);
        }
    }


    // Function to render buttons based on step
    const renderButtons = () => {
        if (currentStep === 1) {
            // Step 1: Show both buttons
            return (
                <>
                    {transactionDetails?.CanStop && <button type="button"
                        className={`w-full mt-8 lg:h-[60px] md:h-[55px] sm:h-[50px] h-[55px] font-hanken-grotesk font-bold lg:text-[16px] md:text-[14px] sm:text-[13px] text-[14px] leading-[16px] border-[var(--modal-btn-color)] border-[2.5px] text-[var(--modal-btn-color)]`}
                        onClick={openContinueModal}
                    >
                        {t('STOP_RECURRING_PAYMENT')}
                    </button>}
                    {transactionDetails?.CanRestore && <button type="button"
                        className={`w-full mt-8 lg:h-[60px] md:h-[55px] sm:h-[50px] h-[55px] font-hanken-grotesk font-bold lg:text-[16px] md:text-[14px] sm:text-[13px] text-[14px] leading-[16px] border-[var(--modal-btn-color)] border-[2.5px] text-[var(--modal-btn-color)]`}
                        onClick={openRestoreRecurringModal}
                    >
                        {t('RESTORE_RECURRING_PAYMENT')}
                    </button>}
                </>
            );
        } else {
            // Step 2: Show only Confirm Stop Payment button with blue background
            return (
                <button type="button"
                    className={`w-full mt-8 lg:h-[60px] md:h-[55px] sm:h-[50px] h-[55px] font-hanken-grotesk font-bold lg:text-[16px] md:text-[14px] sm:text-[13px] text-[14px] leading-[16px] bg-[#2965FB] text-white border-[#2965FB] border-[2.5px]`}
                    onClick={handleConfirmStopPayment}
                >
                    {t('CONFIRM_STOP_PAYMENT')}
                </button>
            );
        }
    }


    const callApiToUnlockCard = async () => {
        setLoading(true)
        setShowModel(false)
        const deviceId = await retrieveData('updatedDeviceId');
        const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
        let object = {
            CardKey: cardDetails.CardKey
        }

        PostRequest(UNLOCK_CARD_API, object, headers).then((response) => {
            setTimeout(() => {
                setLoading(false)
            }, 500);
            let responseObj = JSON.parse(response);
            if (responseObj.ResponseCode == STATUS_SUCCESS_CODE) {
                setTimeout(() => {
                    updateCardStatus(cardDetails.CardKey, responseObj.Response)
                    showAlertModal(true, t("success_heading"), t("this_card_is_now_unocked"), t('you_can_use_your_card'), true, false, t('back_to_card_services'), '', true, require('../../../../assets/images/unlock_green_tick.png'), '', false, false, true, false)
                }, 1000);
            } else {
                var arrMessages = responseObj.Messages;
                var message = arrMessages[0];
                var displayText = message.DisplayText;
                showAlertModal(true, t("oops_exclamation"), '', displayText, true, true, t('home'), t('back_to_card_services'), true, require('../../../../assets/images/warning.png'), '', false, false, true, false)
                setTimeout(() => {
                }, 1000);
            }
        });
    }

    const updateCardStatus = (cardKey, response, type) => {
        const updatedCardIndex = cards?.findIndex(card => card.CardKey === cardKey);
        if (updatedCardIndex !== -1) {
            const updatedCard = {
                ...cards[updatedCardIndex],
                Status: response.Status,
                SubStatus: response.SubStatus,
                StatusCode: response.StatusCode,
                SubStatusCode: response.SubStatusCode,
            };
            if (type == t('activate_card') && response.CardDisplayNumber != undefined && response.CardDisplayNumber != null) { updatedCard.CardDisplayNumber = response.CardDisplayNumber }
            if (type == t('activate_card')) {
                updatedCard.CardKey = response.CardKey;
            }
            const updatedArray = [updatedCard, ...cards.filter(card => card.CardKey !== cardKey)]
            setUpdatedArray(updatedArray);
            dispatch({ type: 'UPDATE_USER_CARDS', payload: { userCards: JSON.stringify(updatedArray) } });
            dispatch({ type: 'SELECTED_USER_CARD_DETAILS', payload: { selectedCardDetails: updatedCard } });

        }
    };

    async function callPostPinChangeApi(status) {
        const deviceId = await retrieveData('updatedDeviceId');
        const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
        const url = POST_PIN_CHANGE + "cardKey=" + cardDetails?.CardKey + "&language=en";

        const body = {
            Success: status == 0 ? true : false,
            ProviderResponse: status == 0 ? "200-0" : ("400-" + status)
        }

        const response = await PostRequest(url, body, headers)
        const responseObj = JSON.parse(response)

        if (responseObj.ResponseCode == STATUS_SUCCESS_CODE) {
            if (responseObj.Response.Success) {
                showAlertModal(true, t("perfect_exclimation"), addLineBreaks(t("your_4_digit_pin_has_been_set_you_may_now")), '', true, false, t('back_to_card_services'), '', true,
                    kudzuPlusTrue ? require('../../../../assets/kudzu-plus-images/Activation_lock.png') : require('../../../../assets/images/activate_change_lock.png'),
                    '', false, false, true, false)
            } else {
                showAlertModal(true, t("oops_exclamation"), '', 'pin Setup Failed', true, true, t('home'), t('back_to_card_services'), true, require('../../../../assets/images/warning.png'), '', false, false, true, false)
            }

        } else {
            var arrMessages = responseObj.Messages;
            var message = arrMessages[0];
            var displayText = message.DisplayText;
            showAlertModal(true, t("oops_exclamation"), '', displayText, true, true, t('home'), t('back_to_card_services'), true, require('../../../../assets/images/warning.png'), '', false, false, true, false)

        }
    }


    // Details
    const [isOpenContuneStopModal, setIsOpenContinueStopModal] = useState(false)
    const [restoreRecurringModalOpen, setRestoreRecurringModalOpen] = useState(false)
    const [restoreSuccessModal, setRrestoreSuccessModal] = useState(false)
    const [stopRecurringSuccessModal ,setStopRecurringSuccessModal] = useState(false)
    const currentDate = new Date();
    const minDate = new Date(currentDate);
    minDate.setMonth(currentDate.getMonth() - 6); // Minimum date is 6 months ago
    const transactionDetails = useSelector(state => JSON.parse(state.cancelTransactionDetails));
    const styleAll = `font-hanken-grotesk  lg:text-[18px] md:text-[15px] sm:text-[14px] text-[16px] leading-[18px] font-[500] break-words text-[var(--text-clr-transactions)]`
    const SelectedCardDetails = useSelector(state => state.selectedCardDetails);
    const isMobile = window.innerWidth < 768

     const isDefaultEndDate = !transactionDetails?.EndDate ||
        transactionDetails?.EndDate === "Not Specified" ||
        transactionDetails?.EndDate?.startsWith("9999");

    const isDefaultStartDate = !transactionDetails?.StartDate ||
    transactionDetails?.StartDate === "Not Specified" ||
    transactionDetails?.StartDate?.startsWith("9999");

    useEffect(() => {
        if (userHasSelectedEndDateRef.current) return;
        const today = new Date();
        setEditableEndDate(today);
        editableEndDateRef.current = today;
        setSelectedDuration(3);
    }, [transactionDetails?.TransactionId]);


    useEffect(() => {
        userHasSelectedEndDateRef.current = false;
    }, [transactionDetails?.TransactionId]);


        const endDateDisabledDates = useMemo(() => {
        const start = transactionDetails?.StartDate ? moment(transactionDetails.StartDate).startOf('day') : moment().startOf('day');
        const dates = [];
        for (let i = 0; i <= 365; i++) {
            dates.push(moment(start).subtract(i, 'day').toDate());
        }
        return dates;
    }, [transactionDetails?.StartDate]);


    
    const openContinueModal =()=>{
      setIsOpenContinueStopModal(true)
    }
    
    const closeContinueModal = () =>{
      setIsOpenContinueStopModal(false)
    }

    const openRestoreRecurringModal =()=>{
      setRestoreRecurringModalOpen(true)
    }
    
    const closeRecurringModal = () =>{
      setRestoreRecurringModalOpen(false)
    }

    const closeRestoreSuccessModal = () =>{
        setRrestoreSuccessModal(false)
    }

    const successRestore = async () => {
        const deviceId = await retrieveData('updatedDeviceId');
        const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
        const cardKey = transactionDetails?.cardDetails?.CardKey;
        const transactionId = transactionDetails?.TransactionId;


        if (!transactionId || !cardKey) {
            showAlertModal(true, t("oops"), '', 'Missing transaction or card information', true, false, t('back_to_card_services'), '', true, require('../../../../assets/images/warning.png'), '', true, false);
            return;
        }
        const url = RESTORE_RECCURRING_PAYMENTS_UPDATED(transactionId, cardKey); 
        setLoading(true);
        try {
            const response = await PostRequest(url, {}, headers);
            setTimeout(() => {
                setLoading(false);
            }, 500);
            const responseObj = JSON.parse(response);
            if (responseObj.ResponseCode == STATUS_SUCCESS_CODE) {
                // Close restore modal and show success modal on API success
                setRestoreRecurringModalOpen(false);
                setRrestoreSuccessModal(true);
            } else {
                setRestoreRecurringModalOpen(false);
                var arrMessages = responseObj.Messages;
                var message = arrMessages[0];
                var displayText = message.DisplayText;
                showAlertModal(true, t("oops"), '', displayText, true, false, t('back_to_card_services'), '', true, require('../../../../assets/images/warning.png'), '', true, false);
            }
        } catch (error) {
            setLoading(false);
            showAlertModal(true, t("oops"), '', 'An error occurred while restoring the payment', true, false, t('back_to_card_services'), '', true, require('../../../../assets/images/warning.png'), '', true, false);
        }
    }


    const closeStopRecurringSucessModal =()=>{
        setStopRecurringSuccessModal(false)
         navigate('/CardServices/CardActionScreen/ManageRecurringPayments')
    }

    const openStopeRecurringSuccessModal =()=>{
        setIsOpenContinueStopModal(false)
        // setStopRecurringSuccessModal(true)
        setCurrentStep(2)
    }

    const backToCardService = () => {
         navigate('/CardServices')
    }

    const backToManageRecurringPayments = () => {
        navigate('/CardServices/CardActionScreen/ManageRecurringPayments')
    }


    
    // Effect for fetching data userProfile
    useEffect(() => {
    }, []);
    useEffect(() => {
        if (SelectedCardDetails != null) { }
    }, [SelectedCardDetails, cardDetails])

    

    
      const onCancelTransfer = async (type) => {
        const deviceId = await retrieveData('updatedDeviceId');
        const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
        let url
        const object = {}
        const cardKey = transactionDetails?.cardDetails?.CardKey
        if (type == t('cancel_series')) {
          url = CANCEL_UPCOMING_TRANSACTION.replace('{transactionId}', transactionDetails?.TransactionId) + `?cardKey=${cardKey}&all=true`
        } else if (type == t('cancel_next_transfer')) {
          url = CANCEL_UPCOMING_TRANSACTION.replace('{transactionId}', transactionDetails?.TransactionId) + `?cardKey=${cardKey}&all=false`
        } else if (type == t('cancel_transfer')) {
          url = CANCEL_UPCOMING_TRANSACTION.replace('{transactionId}', transactionDetails?.TransactionId) + `?cardKey=${cardKey}&all=false`
        }
        setLoading(true)
        const response = await PostRequest(url, object, headers)
        setTimeout(() => {
          setLoading(false)
        }, 500);
        const responseObj = JSON.parse(response)
        if (responseObj.ResponseCode == STATUS_SUCCESS_CODE) {
          setTimeout(() => {
            if (type == t('cancel_series')) {
              showAlertModal(true, t("success"), isMobile ? addLineBreaks(t("this_scheduled_transfer_series_cancelled_mobile")) : addLineBreaks(t("this_scheduled_transfer_series_cancelled")), '', true, false, t('back_to_card_services'), '', true, require('../../../../assets/images/illo_transaction_cancel.png'), '', true, false)
            } else if (type == t('cancel_next_transfer')) {
              showAlertModal(true, t("success"), isMobile ? addLineBreaks(t("this_upcoming_transfer_cancelled_mobile")) : addLineBreaks(t("this_upcoming_transfer_cancelled")), '', true, false, t('back_to_card_services'), '', true, require('../../../../assets/images/illo_transaction_cancel.png'), '', true, false)
            } else {
              showAlertModal(true, t("success"), isMobile ? addLineBreaks(t("your_transfer_cancelled_mobile")) : addLineBreaks(t("your_transfer_cancelled")), '', true, false, t('back_to_card_services'), '', true, require('../../../../assets/images/illo_transaction_cancel.png'), '', true, false)
            }
          }, 1000);
        } else {
          var arrMessages = responseObj.Messages;
          var message = arrMessages[0];
          var displayText = message.DisplayText;
          showAlertModal(true, t("oops"), '', displayText, true, false, t('back_to_card_services'), '', true, require('../../../../assets/images/illo_transaction_cancel.png'), '', true, false)
          return
        }
      };
      const onCancelClick = (type) => {
        if (type == t('cancel_series')) {
          showAlertModal(true, t("are_you_sure"), isMobile ? t("please_confirm_cancel_series_mobile") : addLineBreaks(t("please_confirm_cancel_series")), '', true, true, t('cancel_series'), t('never_mind'), true, require('../../../../assets/images/illo_transaction_cancel.png'), '', false, true)
        } else if (type == t('cancel_next_transfer')) {
          showAlertModal(true, t("are_you_sure"), isMobile ? t("please_confirm_cancel_next_transfer_mobile") : addLineBreaks(t("please_confirm_cancel_next_transfer")), '', true, true, t('cancel_next_transfer'), t('never_mind'), true, require('../../../../assets/images/illo_transaction_cancel.png'), '', false, true)
        } else if (type == t('cancel_transfer')) {
          showAlertModal(true, t("are_you_sure"), isMobile ? t("please_confirm_cancel_this_transfer_mobile") : addLineBreaks(t("please_confirm_cancel_this_transfer")), '', true, true, t('cancel_transfer'), t('never_mind'), true, require('../../../../assets/images/illo_transaction_cancel.png'), '', false, true)
        }
      }
    
      const handleReportAProblem=()=>{
        showAlertModal(true, isMobile ? t("need_to") : '', isMobile ? t("we_r_here_to_help") : addLineBreaks(t("need_to_here_to_help")), <p>{t("call")} <span className='font-[600px] text-[var(--modal-text-highlight)]'>{t('1-855-751-0025')}</span> {t('to_report')} <span className='font-[600px] text-[var(--modal-text-highlight)] cursor-pointer pointer-events-auto' onClick={()=>navigate('/Help/ContactUs')} >{t('customer_care')}</span> {t('team_to_help')}</p>, true, true, t('back_to_card_services'), t('cancel'), true, require('../../../../assets/images/illo-report.png'), '', false, true, true)
    
      }
    
    
    
 
    
 

    return (
        <HomeLayout>
            <CardMenu handleCardAction={handleCardAction} />
            <div className='md:w-[150px] sm:w-[30px] w-[0px]'></div>
            <div className='flex flex-col lg:w-[860px] md:w-[860px] sm:w-[464px] w-[100%] animate__animated animate__fadeInRight'>
                <DynamicCard
                   header={!showSetupPinWebPage}
                    CardRadius={true}
                  //  footer={true}
                  //  footerContent={<Footer />}
                    cardWidth={width.allpolicies}
                    HeaderRadius={true}
                    isWhite={appThemeData.isWhiteBgForCard}
                    isDarkForKudzu={appThemeData.isDarkBgForCard}
                    backgroundColor={'--cardHeading-bg'}
                    HeaderContent={
                        <>
                            <CardHeading heading={t('CARD_SERVICE_MANAGE_RECURRING_PAYMENTS')} />
                        </>
                    } >
                    {kudzuPlusTrue ? '' : <hr className="h-0.5 bg-[#A3CEBB] border-0" />  }      

                    <div className='md:pb-[9rem] pb-[5rem] mt-6 sm:px-0 px-4'>
                        {/* Transactions */}
                        <div className='mb-10'>
                            <p className={`font-hanken-grotesk 
                                              uppercase lg:text-[13px] md:text-[13px] sm:text-[13px] text-[10px]
                                               font-[600] tracking-[2px] ${kudzuPlusTrue ? "text-[#779CE5]" : "text-gray-400"}`}>{t('transactions')}</p>
                        </div>
                        <div className='flex flex-row sm:items-center justify-between w-full'>
                            <div className='md:w-[10%] sm:w-[20%]'>
                                <img src={transactionDetails?.IconUri} alt="Icon" className='lg:h-[44px] md:w-[38px] md:h-[38px] sm:h-[30px] sm:w-[30px] h-[40px] w-[40px] lg:w-[44px]' />
                            </div>
                            <div className={`lg:w-1/4 md:w-[30%] sm:w-1/2 w-[57%] ${styleAll} `}>
                                <p>{transactionDetails?.Description}</p>
                                <p className='block sm:hidden font-hanken-grotesk text-[#262B3A] lg:text-[13px] md:text-[13px] sm:text-[13px] text-[14px] font-[400] mt-1 opacity-[50%]'>{moment(transactionDetails?.TransactionDate).format('MMM DD')}</p>
                            </div>
                            <div className={`hidden sm:block sm:w-1/4 text-center ${styleAll}`}>
                                <p>{moment(transactionDetails?.TransactionDate).format('MMM DD')}</p>
                            </div>
                            <div className={`sm:w-1/5 ${styleAll}`}>
                                <p className='flex justify-end'>{parseInt(transactionDetails?.Amount)}.{(Math.abs(transactionDetails?.Amount) % 1).toFixed(2).slice(2)}</p>
                            </div>
                        </div>
                        <div className='border-b-[2.5px] opacity-50 border-[var(--transactions-acc-number-border)] mt-6'></div>

                        <div class="flex justify-center flex-col items-center">

                            <div class="md:w-[75%] w-full sm:mt-14 mt-8">
                                <p className={`mb-8 font-hanken-grotesk uppercase lg:text-[13px] md:text-[13px] sm:text-[11px] text-[10px] font-[600] tracking-[2px] ${kudzuPlusTrue ? "text-[#779CE5]" : "text-gray-400"}`}>{t('from')}</p>
                                <p className={`${styleAll}`}>{transactionDetails?.From}</p>
                            </div>

                            <div class="sm:flex md:w-[75%] w-full sm:mt-14 mt-8">
                                <div className='sm:w-[70%]'>
                                    <p className={`mb-8 font-hanken-grotesk uppercase lg:text-[13px] md:text-[13px] sm:text-[11px] text-[10px] font-[600] tracking-[2px] ${kudzuPlusTrue ? "text-[#779CE5]" : "text-gray-400"}`}>{t('merchant')}</p>
                                    <p className={`mb-8 sm:mb-0 ${styleAll}`}>{transactionDetails?.MerchantName === "" ? '---' : transactionDetails?.MerchantName}</p>
                                </div>
                                {/* <div className='sm:w-[70%]'>
                                               <p className='mb-8 font-hanken-grotesk text-[#262B3A] uppercase lg:text-[13px] md:text-[13px] sm:text-[11px] text-[10px] font-[600] tracking-[2px] opacity-[50%]'>{t('to')}</p>
                                               <p className={`mb-8 sm:mb-0 ${styleAll}`}>{transactionDetails?.To}</p>
                                             </div> */}
                                <div className='sm:w-[30%]'>
                                    <p className={`mb-8 font-hanken-grotesk uppercase lg:text-[13px] md:text-[13px] sm:text-[11px] text-[10px] font-[600] tracking-[2px] ${kudzuPlusTrue ? "text-[#779CE5]" : "text-gray-400"}`}>{t('amount')}</p>
                                    <p className={`mb-8 sm:mb-0 ${styleAll}`}>{parseInt(transactionDetails?.Amount)}.{(Math.abs(transactionDetails?.Amount) % 1).toFixed(2).slice(2)}</p>
                                </div>
                            </div>
                            <>
                                <div class="sm:flex md:w-[75%] w-full sm:mt-14">
                                    <div className='sm:w-[70%]'>
                                        <p className={`mb-8 font-hanken-grotesk uppercase lg:text-[13px] md:text-[13px] sm:text-[11px] text-[10px] font-[600] tracking-[2px] ${kudzuPlusTrue ? "text-[#779CE5]" : "text-gray-400"}`}>{t('start_date')}</p>
                                        <p className={`mb-8 sm:mb-0 ${styleAll}`}>{isDefaultStartDate ? "----" : moment(transactionDetails?.StartDate).format('MMMM DD, YYYY')}</p>
                                    </div>
                                    {<div className="sm:w-[30%]">
                                        <div className="flex items-center gap-2 mb-8">
                                            <p className={`font-hanken-grotesk uppercase lg:text-[13px] md:text-[13px] sm:text-[11px] text-[10px] font-[600] tracking-[2px] ${kudzuPlusTrue ? "text-[#779CE5]" : "text-gray-400"}`}>{t('end_date')}</p>
                                            <LocalClickableTooltip text={addLineBreaks(t('TRANSACTIONS_AUTHORIZED_AFTER_DATE'))} trigger="click">
                                                <img src={ToolTipQuestionMark} className="h-4 w-4.5 cursor-pointer" alt="tooltip" />
                                            </LocalClickableTooltip>
                                        </div>
                                        {currentStep === 1 ? (
                                        <p className={`mb-8 sm:mb-0 ${styleAll}`}>{isDefaultEndDate ? "----" : moment(transactionDetails?.EndDate).format("MMMM DD, YYYY")}</p>
                                        ) : (
                                            <div className='flex flex-col'>
                                                <p className={`mb-2 ${styleAll}`}>
                                                  {userHasSelectedEndDateRef.current
                                                        ? (editableEndDate ? moment(editableEndDate).format("MMMM DD, YYYY") : "----")
                                                        : (isDefaultEndDate
                                                            ? "----"
                                                            : moment(transactionDetails?.EndDate).format("MMMM DD, YYYY"))}
                                                </p>
                                                <span
                                                    onClick={() => setIsStopPaymentDurationModalOpen(true)}
                                                    className="font-hanken-grotesk font-bold text-[14px] leading-[16px] text-[#2965FB] cursor-pointer"
                                                >
                                                    {t('EDIT')}
                                                </span>
                                            </div>
                                        )}
                                    </div>}
                                </div>

                                <div class="sm:flex md:w-[75%] w-full sm:mt-14">
                                    <div className='sm:w-[70%]'>
                                        <p className={`mb-8 font-hanken-grotesk uppercase lg:text-[13px] md:text-[13px] sm:text-[11px] text-[10px] font-[600] tracking-[2px] ${kudzuPlusTrue ? "text-[#779CE5]" : "text-gray-400"}`}>{t('LAST_PAYMENT')}</p>
                             <p className={`mb-8 sm:mb-0 ${styleAll}`}>
  {!transactionDetails?.LastTransactionDate ||
   transactionDetails?.LastTransactionDate?.startsWith("9999")
    ? "---"
    : moment(transactionDetails.LastTransactionDate).format("MMMM DD, YYYY")}
</p>

                                    </div>
                                    <div className='sm:w-[30%]'>
                                        <p className={`mb-8 font-hanken-grotesk uppercase lg:text-[13px] md:text-[13px] sm:text-[11px] text-[10px] font-[600] tracking-[2px] ${kudzuPlusTrue ? "text-[#779CE5]" : "text-gray-400"}`}>{t('frequency')}</p>
                                        <p className={`mb-8 sm:mb-0 ${styleAll}`}>{transactionDetails?.FrequencyValue ? transactionDetails.FrequencyValue : '---'}</p>
                                    </div>
                                </div>
                            </>
                            <div class="md:w-[75%] w-full sm:mt-14 mt-2">
                                <>
                                    <div className="  flex flex-row cursor-pointer items-center mb-14" onClick={() => { handleReportAProblem() }}>
                                        <img onClick={() => { handleReportAProblem() }} src={report_a_problem_flag} className='w-[10px] h-[12px] sm:w-[11px] sm:h-[14px] mr-3' alt="arrow" />
                                        <p className="font-hanken-grotesk text-[14px] leading-[14px] sm:font-[700] sm:text-[12px] sm:leading-[20px] font-[600] md:text-[16px] md:leading-[24px] text-[#2965FB]"
                                            tabIndex={0}
                                            onClick={() => { handleReportAProblem() }}
                                            onKeyDown={(event) => {
                                                if (event.key === "Enter") {
                                                    event.preventDefault();
                                                    handleReportAProblem()
                                                }
                                            }}
                                        >{t('report_a_problem')}</p>
                                    </div>
                                    <hr className="h-0.5 bg-[#E7E4DC] border-0" />
                                    <div className="mt-8 flex items-start gap-4">
                                        <img src={dollorRecuuring} alt="Payments" className="w-16 h-16 sm:w-20 sm:h-20" />
                                        <div className="flex flex-col">
                                            <p className={`font-serif-pro font-normal text-[18px] sm:text-[18px] md:text-[20px] mb-4 sm:mb-6 ${kudzuPlusTrue ? 'text-white' : 'text-[#000000]'}`}> {t('MANAGE_RECURRING_PAYMENTS')} </p>
                                            <p className={`font-hanken-grotesk text-[12px] sm:text-[13px] md:text-[14px] mb-4 ${kudzuPlusTrue ? "text-[#779CE5]" : "text-[#000000]"}`}> {t('Easily_manage_your')} </p>
                                            {/* <p className="font-hanken-grotesk font-bold text-[#2965FB] mt-2 cursor-pointer text-[13px] sm:text-[14px] md:text-[15px] lg:text-[16px]" onClick={() => navigate(-1)}> {t('View_Recurring_Payments')} </p> */}
                                        </div>
                                    </div>
                                    {/* <button
                                        //  onKeyDown={(event) => { if (event.key === "Enter") { event.preventDefault(); onCancelClick(t('cancel_next_transfer')) } }}
                                        className={`w-full mt-8 lg:h-[60px] md:h-[55px] sm:h-[50px] h-[55px] font-hanken-grotesk font-bold lg:text-[16px] md:text-[14px] sm:text-[13px] text-[14px] leading-[16px] border-[var(--modal-btn-color)] border-[2.5px] text-[var(--modal-btn-color)]`}
                                        //onClick={(event) => { event.target.style.opacity = 0.8; setTimeout(() => { event.target.style.opacity = 1; }, 200); onCancelClick(t('cancel_next_transfer')) }}
                                        onClick={openContinueModal}
                                    >
                                        {t('STOP_RECURRING_PAYMENT')}
                                    </button>

                                     <button
                                        //  onKeyDown={(event) => { if (event.key === "Enter") { event.preventDefault(); onCancelClick(t('cancel_next_transfer')) } }}
                                        className={`w-full mt-8 lg:h-[60px] md:h-[55px] sm:h-[50px] h-[55px] font-hanken-grotesk font-bold lg:text-[16px] md:text-[14px] sm:text-[13px] text-[14px] leading-[16px] border-[var(--modal-btn-color)] border-[2.5px] text-[var(--modal-btn-color)]`}
                                        //onClick={(event) => { event.target.style.opacity = 0.8; setTimeout(() => { event.target.style.opacity = 1; }, 200); onCancelClick(t('cancel_next_transfer')) }}
                                        onClick={openRestoreRecurringModal}
                                    >
                                        {t('RESTORE_RECURRING_PAYMENT')}
                                    </button> */}
                                    {renderButtons()}
                                </>
                            </div>
                        </div>
                    </div>

                </DynamicCard>
            </div>
            <Modal
                isOpen={isOTPVerifyModalOpen}
                onClose={closeOTPVerifyModal}
                isLogo={false}
                subHeaderMsg={<p className="font-hanken-grotesk modal-title lg:text-[18px] md:text-[17px] sm:text-[15px] text-[14px] font-normal cursor-pointer pointer-events-none">{t("standard_msg_and_data_rates_may_apply")}</p>}
                title={<p className={HighlightMsgStyles}> {t("security_check_custom2fa")}</p>}
                subtitle={<p className={HeaderMsgStyles}>{t("we_are_sending_text")}</p>}
                content={<div className="mt-10"><Custom2FA type={t("activate_card")} onClose={closeOTPVerifyModal} verificationSuccess={verificationSuccess} verificationFailure={() => { }} /></div>}
            />
            {showModel &&
                <CustomAlertModel
                    isOpen={showModel}
                    onClose={closeModel}
                    image={modelImage}
                    highlightMsg={<p className={`${HighlightMsgStyles} sm:flex block flex-col`}>{highlightMsg}
                        <span className={HeaderMsgStyles}> {headerMsg}</span></p>}
                    subHeaderMsg={<p className={SubHeaderMsgStyles}>{subHeaderMsg}</p>}
                    btn1Exists={btn1Exists}
                    btn2Exists={btn2Exists}
                    btn1Text={btn1Text} btn2Text={btn2Text}
                    btn1TypeAcpt={btn1TypeAcpt}
                    verificationFailure={() => { }}
                    footerMsg={<p className={SubHeaderMsgStyles}>{footerMsg}</p>}
                    onAcptBtnClick={onAcptBtnClick}
                    subFooter={<p className={SubHeaderMsgStyles}>{subFooter}</p>}
                    onCancelBtnClick={onCancelBtnClick}
                    showErrorImg={false}
                    isBorderNone={isBorderNone}
                    btn1Focus={btn1Focus}
                    btn2Focus={btn2Focus}
                />
            }

              {/* Continue modla for stop recurring payment */}
             {isOpenContuneStopModal && (
                    <Modal
                      isOpen={isOpenContuneStopModal}
                      onClose={closeContinueModal}
                      defaultCornerRadius={false}
                      isLogo={false}
                      Fullheight={true}
                      title={<p className={HeadingUpdatedStyles}><span className={HeadingStyles}>Are you sure?</span></p>}
                      subHeaderMsg={
                        <span className={HeadingUpdatedStyles}>
                        {t('CONTINUE_MODAL_SUB_HEADING')}
                        </span>}
                      content={
                       <div className=' flex flex-col justify-center items-center w-full'>
                          <div className="flex items-start gap-2">
                            <img src={appThemeData.OopsIcon} alt="oops" className="md:w-[20px] md:h-[20px] sm:w-[14px]
                    sm:h-[14px] w-[15px] h-[15px] mt-1 sm:mt-0 md:mt-1  self-start" />
                            <p className={`font-hanken-grotesk lg:text-[16px] md:text-[16px] sm:text-[16px] text-[14px] font-[400] sm:font-[500] leading-[24px] sm:leading-[22px] md:leading-[28px] text-[var(--modal-text-heading-clr)]`}>{t('CONTINUE_CONTENT_ONE')}</p>
                          </div>
                          
                         <img src={dollorRecuuring} alt="complete" className='lg:w-[120px] md:w-[100px] sm:w-[92px] w-[100px] lg:my-1 md:my-14 sm:my-10 my-10' />
                          <p className={`font-hanken-grotesk lg:text-[16px] md:text-[16px] sm:text-[16px] text-[14px] font-[400] sm:font-[500] leading-[24px] sm:leading-[22px] md:leading-[28px] text-[var(--modal-text-heading-clr)] lg:mb-[30px] md:mb-[40px] sm:mb-[40px] mb-[40px]`}>{t('CONTINUE_MODAL_FOOTER_TEXT')}</p>
                          <div className="w-full flex justify-between items-center mt-6">
                            <button
                              type="button"
                              className={continueButtonClasses}
                               onClick={closeContinueModal}
                            >
                              {t('Cancel')}
                            </button>
            
                            <button
                              type="button"
                              className={continueButtonClasses}
                            onClick={openStopeRecurringSuccessModal}
                            >
                              {t('Continue')}
                              <img
                                src={appThemeData.SignupNextArrow}
                                className={` 
                                     ml-2`}
                                alt="Arrow"
                              />
                            </button>
                          </div>
                        </div>
                      }
                    />
                  )}
                    

                {/* Continue modal for restore recurring payments */}
                   {restoreRecurringModalOpen && (
                    <Modal
                      isOpen={restoreRecurringModalOpen}
                      onClose={closeRecurringModal}
                      defaultCornerRadius={false}
                      isLogo={false}
                      Fullheight={true}
                      title={<p className={HeadingUpdatedStyles}><span className={HeadingStyles}>Are you sure?</span></p>}
                      subHeaderMsg={
                        <span className={HeadingUpdatedStyles}>
                        {t('RESTORE_RECCURING_MODAL_SUB_HEADING')}
                        </span>}
                      content={
                       <div className=' flex flex-col justify-center items-center w-full'>
                       

                                <div className="flex flex-col gap-20 justify-center mb-[100px]">
                                    <div className="flex flex-col justify-center items-center w-full">
                                        
                                    </div>
                                </div>
                          
                         <img src={dollorRecuuring} alt="complete" className='lg:w-[120px] md:w-[100px] sm:w-[92px] w-[100px] lg:my-1 md:my-14 sm:my-10 my-10' />
                    <div className="flex flex-col gap-20 justify-center mb-[150px]">
                                    <div className="flex flex-col justify-center items-center w-full">
                                        
                                    </div>
                                </div>
                          <div className="w-full flex justify-between items-center mt-6">
                            <button
                              type="button"
                              className={continueButtonClasses}
                               onClick={closeRecurringModal}
                            >
                              {t('Cancel')}
                            </button>
            
                            <button
                              type="button"
                              className={continueButtonClasses}
                              onClick={successRestore}
                            >
                              {t('Continue')}
                              <img
                                src={appThemeData.SignupNextArrow}
                                className={` 
                                     ml-2`}
                                alt="Arrow"
                              />
                            </button>
                          </div>
                        </div>
                      }
                    />
                  )}

                

                 {/* Restore Success modal */}
                   {restoreSuccessModal && (
                    <Modal
                      isOpen={restoreSuccessModal}
                      onClose={closeRestoreSuccessModal}
                      defaultCornerRadius={false}
                      isLogo={false}
                      Fullheight={true}
                      title={<p className={HeadingUpdatedStyles}><span className={HeadingStyles}>Okay!</span></p>}
                      subHeaderMsg={
                        <span className={HeadingUpdatedStyles}>
                        {t('This recurring payment has been restored.')}
                        </span>}
                      content={
                          <div className=' flex flex-col justify-center items-center w-full'>
                              <div className="flex flex-col gap-20 justify-center mb-[0px]">
                                  <div className="flex flex-col justify-center items-center w-full">

                                  </div>
                              </div>
                              <img src={Dollor_Tick} alt="complete" className='lg:w-[250px] md:w-[100px] sm:w-[92px] w-[100px] lg:h-[250px] md:h-[100px] sm:h-[92px] h-[100px] lg:my-1 md:my-14 sm:my-10 my-10' />
                              <div className=' flex flex-col justify-center items-center gap-8 w-full'>
                                  <button type="button" class="font-hanken-grotesk lg:text-[18px] md:text-[17px] 
                                   sm:text-[15px] text-[16px] font-[500] sm:font-bold leading-[24px] sm:leading-[12px] md:leading-[16px] bg-[#2965FB] text-white cursor-pointer border-2 px-2 py-4 border-[#2965FB] w-full"
                                   onClick={backToCardService}
                                  >{t('BackToCardServices')}</button>
                              </div>
                          </div>
                      }
                    />
                  )}



                   {/* Stop Recurring Success modal */}
                   {stopRecurringSuccessModal && (
                    <Modal
                      isOpen={stopRecurringSuccessModal}
                      onClose={closeStopRecurringSucessModal}
                      defaultCornerRadius={false}
                      isLogo={false}
                      Fullheight={true}
                      title={<p className={HeadingUpdatedStyles}><span className={HeadingStyles}>Okay!</span></p>}
                      subHeaderMsg={
                        <span className={HeadingUpdatedStyles}>
                        {t('This recurring payment has been stopped successfully.')}
                        </span>}
                      content={
                          <div className=' flex flex-col justify-center items-center w-full'>
                              <div className="flex flex-col gap-20 justify-center mb-[0px]">
                                  <div className="flex flex-col justify-center items-center w-full">

                                  </div>
                              </div>
                              <img src={Dollor_Tick} alt="complete" className='lg:w-[250px] md:w-[100px] sm:w-[92px] w-[100px] lg:h-[250px] md:h-[100px] sm:h-[92px] h-[100px] lg:my-1 md:my-14 sm:my-10 my-10' />
                              <div className=' flex flex-col justify-center items-center gap-8 w-full'>
                                  <button type="button" class="font-hanken-grotesk lg:text-[18px] md:text-[17px] 
                                   sm:text-[15px] text-[16px] font-[500] sm:font-bold leading-[24px] sm:leading-[12px] md:leading-[16px] bg-[#2965FB] text-white cursor-pointer border-2 px-2 py-4 border-[#2965FB] w-full"
                                   onClick={backToManageRecurringPayments}
                                  >{t('BackToAccount')}</button>
                              </div>
                          </div>
                      }
                    />
                  )}
            {/* Stop Payment Duration Modal */}
            <StopPaymentDurationModal 
                isOpen={isStopPaymentDurationModalOpen} 
                onClose={() => setIsStopPaymentDurationModalOpen(false)}
                onDateSelect={({ selectedDate, duration }) => {
                    const dateToSet = selectedDate ?? new Date();
                    setEditableEndDate(dateToSet);
                    editableEndDateRef.current = dateToSet;
                    setSelectedDuration(duration ?? 3);
                    userHasSelectedEndDateRef.current = true;
                    setIsStopPaymentDurationModalOpen(false);
                }}
            />
            {loading && <Loader />}
        </HomeLayout>
    )
}

export default withOidcSecure(ManageRecurringPaymentsDetails);
  